// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__LGn4O","options":"AnswerScale_options__2c-ww","selected":"AnswerScale_selected__3T3Y1"};